import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { PopoverDropdown } from "../../../../Core/Components/CustomDropdown";
import { timeSlots } from "../../../Sessions/CreateSession/constants";

dayjs.extend(customParseFormat);

const HubAssignmentForm = ({
  deliveryPrice: propDeliveryPrice,
  setDeliveryPrice: propSetDeliveryPrice,
}) => {
  const { currentRequest } = useSelector((state) => state.requests);

  const rawDate =
    currentRequest?.metaData?.deliveryDate ||
    currentRequest?.metaData?.delivery_date;
  const parsedDate = rawDate
    ? dayjs(rawDate, ["DD/MM/YYYY", "YYYY-MM-DD"])
    : dayjs();

  const [pickupDate, setPickupDate] = useState(
    parsedDate.isValid() ? parsedDate : dayjs(),
  );
  const [localDeliveryPrice, setLocalDeliveryPrice] = useState("");

  const deliveryPrice =
    propDeliveryPrice !== undefined ? propDeliveryPrice : localDeliveryPrice;
  const setDeliveryPrice = propSetDeliveryPrice || setLocalDeliveryPrice;

  const rawTime =
    currentRequest?.metaData?.timeSlot ||
    currentRequest?.metaData?.time_slot ||
    "";

  const { control, formState, setValue, clearErrors } = useForm({
    defaultValues: {
      startTime: rawTime,
    },
  });

  return (
    <div className="mt-6 flex flex-col gap-5">
      <div>
        <p className="font-aileron text-xs font-normal text-dark-gray capitalize mb-1.5">
          Pickup Date
        </p>

        <DatePicker
          value={pickupDate}
          onChange={(date) => setPickupDate(date)}
          format="dddd, MMMM D"
          className="w-full h-8"
          suffixIcon={null}
          styles={{
            input: {
              color: "#000",
            },
          }}
        />
      </div>
      <div>
        <p className="font-aileron text-xs font-normal text-dark-gray capitalize mb-1.5">
          Pickup time
        </p>
        <Controller
          name="startTime"
          control={control}
          rules={{ required: "Required." }}
          render={({ field }) => (
            <PopoverDropdown
              {...field}
              placeholder="Select A Time"
              formState={formState}
              options={timeSlots}
              onSelect={(data) => {
                setValue("startTime", data.value);
                clearErrors("startTime");
              }}
              className="max-h-[200px] overflow-y-scroll"
              valueStyle={{ width: "512px" }}
              contentContainerStyle={{ width: "512px" }}
            />
          )}
        />
      </div>

      <div>
        <p className="font-aileron text-xs font-normal text-dark-gray capitalize mb-1.5">
          Delivery Price
        </p>

        <div className="flex items-center gap-3">
          <input
            value={deliveryPrice}
            onChange={(e) => setDeliveryPrice(e.target.value)}
            placeholder="Enter Amount"
            className="h-8 flex-1 rounded-md border border-light-grey px-3.5 py-[9px] font-aileron font-semibold text-xs leading-none text-black outline-none focus:border-primary focus:ring-0"
          />

          <span className="font-aileron font-semibold text-xs leading-none text-black">
            Ksh
          </span>
        </div>
      </div>
    </div>
  );
};

export default HubAssignmentForm;
